import { ZipApi } from '../../lib/ZipApi';
import { directoryStore } from '../DirectoryStore';
import { ObjectDefinition } from '../../types/DataSyncItem';
import { DataSyncObjectsStore } from './DataSyncObjectsStore';
import { getApiErrorMessage } from '../../lib/ZipApiError';
import { showToasts } from '../../lib/toaster';

export default class DataSyncHubAppObjectsStore extends DataSyncObjectsStore {

  protected async fetchSourceObjectDefinitions(): Promise<ObjectDefinition[]> {
    if (!directoryStore.trackerId || !this.instanceId) {
      return [];
    }

    const trackerId = directoryStore.trackerId;
    const instanceId = this.instanceId as string;

    const sources = await ZipApi.listAppSources(trackerId, instanceId);

    return await Promise.all(
      sources.map(async (source) => {
        const schema = await ZipApi.listHubAppSourceSchema(
          trackerId,
          instanceId,
          source.name
        );

        return schema ? {
          object_name: source.name,
          fields: schema.fields
        } : null;
      })
    ).then((results) => results.filter(Boolean) as ObjectDefinition[]);
  }

  protected async fetchDestinationObjectDefinitions(): Promise<ObjectDefinition[]> {
    if (!directoryStore.trackerId || !this.instanceId) {
      return [];
    }

    const trackerId = directoryStore.trackerId as string;
    const instanceId = this.instanceId as string;

    const destinations = await ZipApi.listAppDestinations(
      trackerId,
      instanceId
    );
    return Promise.all(
      destinations.map(async (destination) => {
        const schema = await ZipApi.listHubAppDestinationSchema(
          trackerId,
          instanceId,
          destination
        );
        return schema && schema.fields
          ? ({
              object_name: destination,
              fields: schema.fields,
            } as ObjectDefinition)
          : null;
      })
    ).then((schemas) => schemas.filter(Boolean) as ObjectDefinition[]);
  }

  protected async handleSourceFetchError(error: any): Promise<void> {
    const message = await getApiErrorMessage(error, 'Unable to fetch source app schema');
    showToasts([{intent: 'danger', message}]);
  }

  protected async handleDestinationFetchError(error: any): Promise<void> {
    const message = await getApiErrorMessage(error, 'Unable to fetch destination app schema');
    showToasts([{intent: 'danger', message}]);
  }
}
